import React from 'react';
import PortfolioWithAI from './PortfolioWithAI';

interface DashboardContentProps {
  onSignOut: () => void;
}

const DashboardContent: React.FC<DashboardContentProps> = ({ onSignOut }) => {
  return (
    <>
      {/* Enhanced Portfolio with AI Integration */}
      <div className="mb-8">
        <PortfolioWithAI />
      </div>
    </>
  );
};

export default DashboardContent;
